import RequestService from "./RequestService";
import { CasuistryAction } from "../entities/company/Assistant/Assistant";

class UsecasesService {
  static async get(): Promise<CasuistryAction[] | Error> {
    const res = await RequestService.post<any>("/usecases/get", {});
    if (res instanceof Error) return res;
    const list: any[] = Array.isArray(res) ? res : [];
    return list.map((item: any) => ({
      code: parseInt(String(item.Code ?? item.code), 10),
      actions: String(item.Actions ?? item.actions ?? "")
        .split(",")
        .filter(Boolean)
        .map(Number)
    }));
  }

  static async set(items: CasuistryAction[]): Promise<unknown | Error> {
    return RequestService.post("/usecases/set", {
      items: items.map((ca) => ({
        code: String(ca.code),
        actions: ca.actions.join(",")
      }))
    });
  }
}

export default UsecasesService;
